import SharedDashboard from 'scoreboard/dashboards/shared-dashboard'

/**
 * Used to create a shared strategy map as an embeddable resource
 */
var SharedStrategyMap = SharedDashboard.extend({
	section: 'strategyMaps'
})

export default SharedStrategyMap

SharedStrategyMap.__filename__ = 'strategy-maps/shared-strategy-map.js'
